<template>
  <v-container fluid ma-0 pa-0>
    <v-card-title class="text-left justify-left p-l-0">
      <div><BackButton :handler="() => {$router.go(-1)}"/></div>
      <h3 class="font-weight-bold basil--text">
        {{ userProfile.name }}
      </h3>
    </v-card-title>
    <v-tabs
        v-model="tabs"
        left
        light
        hide-slider
        class=" shadow-0 q-profile-tabs rounded p-x-4 m-l-5 tabs"
        slider-color="transparent"
        style="width: fit-content;"
    >
      <v-tabs-slider></v-tabs-slider>
      <template v-for="(loopTab,index) in allTabs">
        <v-tab
            :ripple="false"
            :key="loopTab.path"
            :class="{'tab':index <= allTabs.length-1,'border-0':index === allTabs.length-1}"
            class="tab"
            :href="`#${loopTab.path}`"
            style="min-width: 120px;"
        >
          <SvgIcon :text="loopTab.name"
                   class="font-normal"
                   :class="{
                    'qp-tab-nav-is-active':loopTab.path === tabs,
                    'qp-tab-nav':loopTab.path !== tabs
                  }"
          >
            <template v-slot:icon>
              <component :is="loopTab.icon" :component="loopTab.icon" />
            </template>
          </SvgIcon>
        </v-tab>
      </template>
    </v-tabs>
    <div class="">
      <div class="">
        <v-tabs-items v-model="tabs">
          <v-tab-item value="profile">
            <div>
              <v-card-text>
                <v-row>
                  <v-col md="3" sm="6" lg="3" xs="12" class="mt-10">
                    <div class="md-card md-theme-default shadow-0 rounded-4" style="min-height: 350px">
                      <div class="md-card-content">
                        <div class="d-flex align-center" style="position: relative;">
                          <v-img
                              v-if="
                          userProfile.profile_image &&
                            userProfile.profile_image != ''
                        "
                              :src="s3BucketURL + userProfile.profile_image"
                              default_image="user"
                              aspect-ratio="1"
                              height="180px"
                              width="180px"
                              style="object-fit: cover; position: absolute; top:-70px; left:25%"
                              class="rounded-circle border-2 shadow-2"
                          ></v-img>
                          <v-img
                              v-else
                              src="./../../assets/images/profile_blank.png"
                              aspect-ratio="1"
                              height="180px"
                              width="180px"
                              style="object-fit: cover; position: absolute; top:-70px; left:25%"
                              class="rounded-circle border-2 shadow-2"
                          ></v-img>
                        </div>
                      </div>
                      <v-row class="mb-2 mt-10 ml-2">
                        <div class="d-flex flex-column align-center justify-center w-full mt-16">
                          <span class="user-name">{{ userProfile.name }}</span>
                          <span class="user-username">{{ userProfile.username }}</span>
                        </div>
                        <v-row>
                          <div class="d-flex justify-center align-center mt-4 w-full gap-x-2">
                              <v-btn
                                  class="black-text"
                                  @click="userFollowing(userProfile.id)"
                                  text
                                  outlined
                              >Following ({{ userProfile.total_following }})
                              </v-btn
                              >
                              <v-btn
                                  class="white--text teal-color"
                                  text
                                  @click="userFollowers(userProfile.id)"
                              >Followers ({{ userProfile.total_followers }})
                              </v-btn
                              >
                          </div>
                        </v-row>
                      </v-row>
                      <div class="w-full d-flex flex-column m-t-8">
                        <div class="w-full d-flex justify-space-between p-x-8">
                          <span class="user-label">Email</span>
                          <span class="user-value">{{ userProfile.email }}</span>
                        </div>
                        <div class="w-full d-flex justify-space-between p-x-8 m-t-4">
                          <span class="user-label">Mobile number</span>
                          <span class="user-value">{{ userProfile.mobile }}</span>
                        </div>
                        <div class="w-full d-flex justify-space-between p-x-8 m-t-4">
                          <span class="user-label">Gender</span>
                          <span class="user-value">{{ userProfile.gender || "NA" }}</span>
                        </div>
                        <div class="w-full d-flex justify-space-between p-x-8 m-t-4">
                          <span class="user-label">Date of birth</span>
                          <span class="user-value">{{ userProfile.dob != null ? userProfile.dob : "NA" }} {{ userProfile.age != null ? '(' +userProfile.age+')' : ''}}
                          </span>

                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col lg="9" xs="12" md="9" sm="6" class="mt-6 p-b-0">
                    <v-col sm="12" class="p-b-0">
                      <div class="md-card md-theme-default shadow-0 rounded-4" style="min-height: 100px">
                        <div class="md-card-content">
                          <h3 class="font-weight-bold basil--text m-b-2">
                            About
                          </h3>
                          <span class="text-capitalize"
                          >{{ userProfile.about || "-" }}
                            </span>
                        </div>
                      </div>
                    </v-col>
                    <v-col sm="12" class="m-t-0 p-t-0">
                      <div class="md-card md-theme-default shadow-0 rounded-4 m-t-0" style="min-height: 200px">
                        <div class="md-card-content">
                          <h3 class="font-weight-bold basil--text m-b-1">
                            Details
                          </h3>
                          <v-divider></v-divider>
                          <div class="d-flex justify-space-between w-full">
                            <div class="div-w20">
                              <p class="details-label">Profession</p>
                              <p class="details-value">{{ userProfile.profession || "" }}</p>
                            </div>
                            <div class="div-w20">
                              <p class="details-label">Company Name</p>
                              <p class="details-value">{{ userProfile.company_name || "" }}</p>
                            </div>
                            <div class="div-w20">
                              <p class="details-label">Email Verified</p>
                              <p class="details-value">{{ userProfile.is_email_verified &&
                              userProfile.is_email_verified == 1
                                  ? userProfile.email_verified_at &&
                                  userProfile.email_verified_at != "null" &&
                                  userProfile.email_verified_at != ""
                                      ? "Yes. At" + userProfile.email_verified_at
                                      : "Yes"
                                  : "No" }}</p>
                            </div>
                            <div class="div-w20">
                              <p class="details-label">Phone Verified</p>
                              <p class="details-value">{{
                                  userProfile.is_phone_verified &&
                                  userProfile.is_phone_verified == 1
                                      ? "Yes"
                                      : "No"
                                }}</p>
                            </div>
                            <div class="div-w20">
                              <p class="details-label">Account Created</p>
                              <p class="details-value">{{
                                  userProfile.created_date
                                      ? userProfile.created_date
                                      : "NA"
                                }}</p>
                            </div>
                          </div>

                          <div class="d-flex justify-space-between w-full m-t-2">
                            <div class="div-w20">
                              <p class="details-label">Last Login</p>
                              <p class="details-value">{{
                                  userProfile.last_login
                                      ? userProfile.last_login
                                      : "NA"
                                }}</p>
                            </div>
                            <div class="div-w20">
                              <p class="details-label">Last seen</p>
                              <p class="details-value">{{
                                  userProfile.is_online &&
                                  userProfile.is_online == 1
                                      ? "Yes"
                                      : userProfile.last_seen &&
                                      userProfile.last_seen != "null" &&
                                      userProfile.last_seen != ""
                                          ? "No. last seen at "
                                          : "No"
                                }}</p>
                            </div>

                            <div class="div-w20">
                              <p class="details-label">Account Type</p>
                              <p class="details-value">{{
                                  userProfile.is_private &&
                                  userProfile.is_private == 1
                                      ? "Private"
                                      : "Public"
                                }}</p>
                            </div>

                            <div class="div-w20">
                              <p class="details-label">Notifications</p>
                              <p class="details-value">{{
                                  userProfile.notification_enabled &&
                                  userProfile.notification_enabled == 1
                                      ? "Enabled"
                                      : "Disabled"
                                }}</p>
                            </div>

                            <div class="div-w20">
                              <p class="details-label">Device Type</p>
                              <p class="details-value">{{
                                  userProfile.device_type || ""
                                }}</p>
                            </div>

                          </div>

                          <div class="d-flex justify-space-between w-full m-t-2">
                            <div class="div-w20">
                              <p class="details-label">Status</p>
                              <p class="details-value">{{
                                  userProfile.status
                                }}</p>
                            </div>
                          </div>

                        </div>
                      </div>
                    </v-col>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-tab-item>
          <v-tab-item value="wallet">
            <wallet/>
          </v-tab-item>
          <v-tab-item value="post">
            <post v-bind="{ userID: Number(userProfile.id) }"></post>
          </v-tab-item>
          <v-tab-item value="comment">
            <comments v-bind="{ userID: Number(userProfile.id) }"/>
          </v-tab-item>
          <v-tab-item value="chat">
            <chats v-bind="{ userID: Number(userProfile.id) }"/>
          </v-tab-item>
          <v-tab-item value="likes">
            <likes v-bind="{ userID: Number(userProfile.id) }"/>
          </v-tab-item>
          <v-tab-item value="attendance">
            <attendance v-bind="{ userID: Number(userProfile.id) }"/>
          </v-tab-item>
        </v-tabs-items>
        <v-dialog
            v-model="followers"
            max-width="400"
            class="rounded-4"
            @input="followersTerm = null"
        >
          <v-card>
            <v-card-title class="border-bottom">

              <div class="w-full">
                <div class="d-flex justify-space-between align-center">
                  <p class="mb-0 font-medium">
                    Followers
                  </p>
                  <v-btn class="shadow-0" fab x-small @click="followers = false;">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

            </v-card-title>
            <v-card-text>
              <v-text-field
                  class="mt-2 m-b-2 q-text-field shadow-0"
                  label="Search.."
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  v-model="followersTerm"
              ></v-text-field>
              <v-list subheader>
                <v-list-item v-for="data in followersData" :key="data.name">
                  <v-list-item-avatar>
                    <v-img
                        v-if="data.profile_image && data.profile_image != ''"
                        :src="s3BucketURL + data.profile_image"
                    ></v-img>
                    <v-img
                        v-else
                        src="./../../assets/images/profile_blank.png"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="following"
            class="rounded-4"
            max-width="400"
            @input="followingTerm = null"
        >
          <v-card>
            <v-card-title class="border-bottom">
              <div class="w-full">
              <div class="d-flex justify-space-between align-center">
                <p class="mb-0 font-medium">
                  Following
                </p>
                <v-btn class="shadow-0" fab x-small @click="following = false;">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                  class="mt-2 m-b-2 q-text-field shadow-0"
                  label="Search.."
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  hide-details
                  v-model="followingTerm"
              ></v-text-field>
              <v-list subheader>
                <v-list-item v-for="data in followingData" :key="data.name">
                  <v-list-item-avatar>
                    <v-img
                        v-if="data.profile_image && data.profile_image != ''"
                        :src="s3BucketURL + data.profile_image"
                    ></v-img>
                    <v-img
                        v-else
                        src="./../../assets/images/profile_blank.png"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ data.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-container>
</template>

<script>
import post from "../Users/tabs/Post";
import comments from "../Users/tabs/Comments";
import likes from "../Users/tabs/Likes";
import attendance from "../Users/tabs/Attendance";
import chats from "../Users/tabs/Chats";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import ProfileIcon from "@/assets/images/misc/profile.svg";
import PostsIcon from "@/assets/images/misc/posts.svg";
import CommentsIcon from "@/assets/images/misc/comments.svg";
import ChatIcon from "@/assets/images/misc/chats.svg";
import LikesIcon from "@/assets/images/misc/likes.svg";
import AttendanceIcon from "@/assets/images/misc/attendance.svg";
import BackButton from "@/components/Common/BackButton.vue";

export default {
  components: {
    BackButton,
    post,
    comments,
    likes,
    attendance,
    SvgIcon,
    chats,
    ProfileIcon,
    PostsIcon,
    CommentsIcon,
    ChatIcon,
    LikesIcon,
    AttendanceIcon,
  },
  computed: {
    allTabs() {
      return [
        {
          name: "Profile",
          icon: ProfileIcon,
          path: 'profile',
        },
        {
          name: "Post",
          icon: PostsIcon,
          path: 'post',
        },
        {
          name: "Comment",
          icon: CommentsIcon,
          path: 'comment',
        },
        {
          name: "Chat",
          icon: ChatIcon,
          path: 'chat',
        },
        {
          name: "Likes",
          icon: LikesIcon,
          path: 'likes',
        },
        {
          name: "Attendance",
          icon: AttendanceIcon,
          path: 'attendance',
        },
      ];
    }
  },
  data() {
    return {
      userProfile: {},
      followers: false,
      following: false,
      followersTerm: null,
      followingTerm: null,
      followingData: [],
      followersData: [],
      tabs: "profile",
    };
  },
  mounted() {
    if (typeof this.$route.params.userId != "undefined") {
      this.getUserProfile(this.$route.params.userId);
    }
  },
  watch: {
    followersTerm(val) {
      if (val == null) return;
      this.userFollowers(this.$route.params.userId, val);
    },
    followingTerm(val) {
      if (val == null) return;
      this.userFollowing(this.$route.params.userId, val);
    },
  },
  methods: {
    getUserProfile(id) {
      this.showLoader('Loading');
      this.tabs = "profile";
      this.$http
          .get("users/user-details/" + id)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.userModal = true;
              this.userProfile = response.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          }).finally(() => {
            this.hideLoader()
      });
    },
    userFollowing(id, val = "") {
      let parameter = {
        user_id: id,
        search: val,
      };
      this.showLoader('loading users..');
      this.$http
          .get("follows/following", {
            params: parameter,
          })
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.followingData = response.data.data;
              this.following = true;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          }).finally(() => {
            this.hideLoader()
      });
    },
    userFollowers(id, val = "") {
      let parameter = {
        user_id: id,
        search: val,
      };
      this.showLoader('loading users..');
      this.$http
          .get("follows/followers", {params: parameter})
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.followersData = response.data.data;
              this.followers = true;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          }).finally(() => {
            this.hideLoader()
      });
    },
  },
};
</script>

<style scoped lang="scss">

.v-btn--active .v-btn__content .v-icon {
  color: #66c8c8 !important;
}

.section {
  margin: 20px 0 50px 0;
  padding: 20px 0 20px;
}

.profile_title {
  padding: 10px;
  text-align: center;
}

.border-2{
  border: 2px solid whitesmoke;
}
.profile_title h1 {
  color: #066a8c;
}

.v-item-group.v-bottom-navigation {
  top: 64px !important;
  z-index: 1;
}

.nav {
  position: relative;
}

.layout.wrap {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-top: 20px;
}

.v-item-group.v-bottom-navigation {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.theme--light.v-bottom-navigation {
  background-color: #edf9ff;
  height: 75px !important;
}

.v-item-group.v-bottom-navigation--grow .v-btn {
  height: 73px;
  padding-top: 10px;
}

.v-bottom-navigation span {
  font-size: 13px;
  padding: 10px;
  text-align: center;
}

.active_tab_profile_fill_icon {
  color: #000000 !important;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;

  svg {
    opacity: 1 !important;
  }
}

.v-btn__content,
.v-btn--fab.v-btn--absolute {
  z-index: 0 !important;
}

.v-btn--fab.v-btn--absolute {
  z-index: 4;
}

.theme--light.v-tabs-items {
  background-color: transparent;
}

.section {
  margin: 20px 0 50px 0;
  padding: 20px 0 20px;
}

.v-tabs__item--active {
  background: #fff;
}

.v-tab {
  min-width: 150px;
}

.v-tab--active {
  background: #fff !important;
  color: rgb(6, 106, 140);
}

.q-profile-tabs {
  background: #fff;
  color: #00000066;
  border: 1px solid #EAEAEA !important;
}

.tab {
  text-transform: capitalize;
  padding-left: 0 !important;
  padding-right: 0 !important;
  font-size: 14px !important;
  width: fit-content;
  justify-content: space-around;
  white-space: nowrap !important;
  max-width: unset !important;

  &:not(.border-0):after {
    border-right: 1px solid #DCDCDC;
    content: " ";
    height: 24px;
  }

  &, & * {
    &:before {
      background: transparent !important;
    }
  }
}

.q-tabs-secondary-profile {
  border-bottom: transparent;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: left;
  margin-bottom: 5px;
}
.user-username{
  font-size: 12px;
  font-weight: 500;
  line-height: 19.36px;
  text-align: left;
  margin-bottom: 5px;
  color: #A3A3A3;
}


.user-label{
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #838383;
}
.user-value{
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: left;
  color: black;
}

.details-label{
  margin-top:8px;
  margin-bottom:4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #838383;
}


.details-value{
  margin-top:5px;
  margin-bottom:2px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: left;
}

.div-w20{
  width:20%;
}
</style>
